import { gql, useQuery } from '@apollo/client';
import { BrandKey } from '@prismamedia/one-brandkey';
import {
  GetSourcesQuery,
  GetSourcesQueryVariables,
  SourceOrderingInput,
} from '__generated__/queries-web';
import { getFilteredBrandKey } from 'utils/queries/variables';

export const GET_SOURCES = gql`
  query GetSources(
    $first: UnsignedInt!
    $where: SourceFilterInput
    $orderBy: [SourceOrderingInput!]
  ) {
    sources(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      brandKey
      status
    }
  }
`;

export const useGetSources = (brandKey: BrandKey | null) =>
  useQuery<GetSourcesQuery, GetSourcesQueryVariables>(GET_SOURCES, {
    variables: {
      orderBy: [SourceOrderingInput.title_ASC],
      first: 100,
      where: getFilteredBrandKey(brandKey),
    },
  });
